import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      q: '広告だけお願いできますか？',
      a: '可能ですが、LPが弱いとCPAが悪化します。最低限の構造チェックを推奨します。'
    },
    {
      q: '小予算でも効果は出ますか？',
      a: 'まずは"勝ち筋の検証"が目的です。少額で反応を見て改善します。'
    },
    {
      q: 'どのCMSでも対応できますか？',
      a: 'WordPress/Shopify/静的LPなど、運用に合わせて進めます。'
    },
    {
      q: '何を用意すればいいですか？',
      a: '現状URL、理想の問い合わせ内容、過去の広告状況（あれば）だけでOKです。'
    }
  ];

  return (
    <section id="faq" className="py-20 md:py-28 bg-white">
      <div className="max-w-[900px] mx-auto px-6 md:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-gray-900 mb-4">
            よくある質問
          </h2>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-gray-50 rounded-xl overflow-hidden">
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 md:px-8 py-5 md:py-6 flex items-center justify-between text-left hover:bg-gray-100 transition-colors cursor-pointer"
              >
                <span className="text-base md:text-lg font-bold text-gray-900 pr-4">{faq.q}</span>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i className={`ri-arrow-${openIndex === index ? 'up' : 'down'}-s-line text-gray-900 text-2xl transition-transform`}></i>
                </div>
              </button>
              {openIndex === index && (
                <div className="px-6 md:px-8 pb-5 md:pb-6">
                  <p className="text-sm md:text-base text-gray-600 leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
